var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 456,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-292 -94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463 151C368.95 151 292 227.95 292 322L292 493 463 493 463 322 349 322C349 258.73 399.73 208 463 208L463 151ZM748 151C653.95 151 577 227.95 577 322L577 493 748 493 748 322 634 322C634 258.73 684.73 208 748 208L748 151Z",
    fill: "#D6FF41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/Quotes.e0f700f6a8e32423940de4207db8a0f2.svg";
export { ForwardRef as ReactComponent };